"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var Logger = /** @class */ (function () {
    function Logger(config) {
        var _this = this;
        this.config = config;
        this.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.info.apply(console, __spreadArray([_this._prefix], args));
        };
        this.log = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this._verbose) {
                console.log.apply(console, __spreadArray([_this._prefix], args));
            }
        };
        var module = config.module, subModule = config.subModule, verbose = config.verbose;
        this._prefix = module + ":" + subModule + ":";
        this._verbose = verbose;
    }
    return Logger;
}());
exports.Logger = Logger;
//# sourceMappingURL=logger.js.map